import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { categoryApi } from '../services/api';
import { CreateCategory } from '../types/api';
import { TODOS_KEY } from './useTodos';
import { TIME_LOGS_KEY } from './useTimeLogs';

export const CATEGORIES_KEY = ['categories'] as const;

export const useCategories = () =>
  useQuery({ queryKey: CATEGORIES_KEY, queryFn: categoryApi.getAll });

export const useCreateCategory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (category: CreateCategory) => categoryApi.create(category),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: CATEGORIES_KEY }),
  });
};

export const useUpdateCategory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<CreateCategory> }) =>
      categoryApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CATEGORIES_KEY });
      // category_name is denormalized onto todos and time logs
      queryClient.invalidateQueries({ queryKey: TODOS_KEY });
      queryClient.invalidateQueries({ queryKey: TIME_LOGS_KEY });
    },
  });
};

export const useDeleteCategory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => categoryApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CATEGORIES_KEY });
      queryClient.invalidateQueries({ queryKey: TODOS_KEY });
      queryClient.invalidateQueries({ queryKey: TIME_LOGS_KEY });
    },
  });
};
